import axios from 'axios'
import store from './store'
import properties from "./properties";
import utils from "./utilities";

export const BASE_URL = process.env.VUE_APP_API_ENDPOINT;

let requests = {

    get(path, getCallBack) {

        axios.get(BASE_URL + path,
            {headers: {
                    'Content-Type': 'application/json',
                    //'Authentication': utils.getLocalStorage('cmt_token')
                }})
            .then((response =>{
                getCallBack(response.data)
            }))
            .catch((error => {
                if (error.response) {
                    properties.getErrorMessage(error.response.data);
                } else {
                    console.error('Network error:', error.message);
                }
                store.commit('setLoadingModal', false);
            }))
    },

    post(path, data,  postCallBack) {

        axios.post(BASE_URL + path,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    //'Authentication': utils.getLocalStorage('cmt_token')
                }
            })
            .then((response =>{
                postCallBack(response.data)
            }))
            .catch((error => {
                if (error.response) {
                    properties.getErrorMessage(error.response.data);
                } else {
                    console.error('Network error:', error.message);
                }
                store.commit('setLoadingModal', false);
            }))
    },

    postForFiles(path, data,  postCallBack) {

        axios.post(BASE_URL + path,
            data,
            {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    //'Authentication': utils.getLocalStorage('cmt_token')
                }
            })
            .then((response =>{
                postCallBack(response)
            }))
            .catch((error => {
                var storeObj = {
                    title: 'Σφάλμα!',
                    text: 'Κάτι πήγε στραβά κατά τη δημιουργία αναφοράς.',
                    color: 'indianRed',
                    class: 'white--text indianRed text-center justify-center'
                };
                if (error.response && error.response.status==405)
                    storeObj.text = 'Για να κατέβει η αναφορά θα πρέπει να έχει προηγηθεί είτε \"Προσωρινή αποθήκευση\" είτε \"Οριστική υποβολή\".';
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', storeObj);
                store.commit('setLoadingModal', false);
            }))
    },


    put(path, data ,  putCallBack) {

        axios.put(BASE_URL + path, data, {
                headers: {
                    'Content-Type': 'application/json',
                    //'Authentication': utils.getLocalStorage('cmt_token')
                }
            }
        )
            .then((response =>{
                putCallBack(response.data)
            }))
            .catch((error => {
                if (error.response) {
                    properties.getErrorMessage(error.response.data);
                } else {
                    console.error('Network error:', error.message);
                }
                store.commit('setLoadingModal', false);
            }))
    },

    delete(path, requestObj, deleteCallBack){

        axios.delete( BASE_URL + path, {
            data: requestObj,
            headers: {
                'Content-Type': 'application/json',
                //'Authentication': utils.getLocalStorage('cmt_token')
            }})
            .then((response) => {
                deleteCallBack(response.data)
            })
            .catch((error =>{
                store.commit('setLoadingModal', false);
                if (error.response) {
                    properties.getErrorMessage(error.response.data);
                } else {
                    console.error('Network error:', error.message);
                }
            }))
    },

    
    requestReport(data, createReportCallBack) {

        axios.put(BASE_URL + 'rest/reports/request', data, {
                headers: {
                    'Content-Type': 'application/json',
                    //'Authentication': utils.getLocalStorage('cmt_token')
                }
            }
        )
            .then((response =>{
                createReportCallBack(response)
            }))
            .catch((error => {
                if (error.response) {
                    properties.getErrorMessage(error.response.data);
                } else {
                    console.error('Network error:', error.message);
                }
                store.commit('setLoadingModal', false);
            }))
    },

    downloadReport(data, requestReportCallBack) {

        axios.put(BASE_URL + 'rest/reports/download', data, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    //'Authentication': utils.getLocalStorage('cmt_token')
                }
            }
        )
            .then((response =>{
                requestReportCallBack(response)
            }))
            .catch((error => {
                if (error.response) {
                    properties.getErrorMessage(error.response.data);
                } else {
                    console.error('Network error:', error.message);
                }
                store.commit('setLoadingModal', false);
            }))
    },

    downloadObjectionFile(pricingHistoryId) {

        axios.post(BASE_URL + 'rest/pricing/get-objection-pdf/' + pricingHistoryId, {}, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json',
                    //'Authentication': utils.getLocalStorage('cmt_token')
                }
            }
        )
        .then((response =>{
            utils.downloadFile(response.headers['content-type'],response.headers['filename'],response.data);
            store.commit('setLoadingModal', false);
        }))
        .catch((error => {
            if (error.response) {
                properties.getErrorMessage(error.response.data);
            } else {
                console.error('Network error:', error.message);
            }
            store.commit('setLoadingModal', false);
        }))
    },


    getYears(getYearsCallBack) {

        axios.get(BASE_URL + 'rest/courses-books/academic-years', {
            headers: {
                'Content-Type': 'application/json',
                'Authentication': utils.getLocalStorage('adm_token')
            }
        })
            .then((response) => {
                getYearsCallBack(response.data)
            })
            .catch((error) => {
                store.commit('setLoadingModal', false);
            })
    },


};

export default requests